import React, { useEffect, useState } from 'react';
import { Button, CheckIcon, FormControl, Image, Input, Modal, NativeBaseProvider, Progress, Select, useMediaQuery, } from 'native-base';
import { View, Text, Keyboard, TouchableWithoutFeedback, StyleSheet, ScrollView, TouchableOpacity, TextInput, ActivityIndicator, SafeAreaView, StatusBar, Platform, BackHandler, Linking, Share, Alert } from 'react-native';
import Btn from "../components/btn"
import Colors from '../constants/Colors';
import { Ionicons, MaterialCommunityIcons, Octicons } from "@expo/vector-icons"
import INPU from '../components/input';
import { useDispatch, useSelector } from 'react-redux';
import { getCity, getProfileinfo, getState, logOut, sendprofile } from '../store/action/userLogin';
import { useIsFocused } from "@react-navigation/native";
import AwesomeAlert from 'react-native-awesome-alerts';

import AsyncStorage from "@react-native-async-storage/async-storage";








const Profile = (props) => {
    const [Ostan, setOstan] = useState("");

    //const tokens = ""
    const tokens = useSelector((store) => store.userLogin.datatoken);
    const dispatch = useDispatch();
    const [loading, setloading] = useState(false)
    const [Wallet, setWallet] = useState(false)
    const [Massage, setMassage] = useState();
    const [namecity, setnamecity] = useState("");
    const [Links, setLinks] = useState([]);
    const [ERROR, setError] = useState(false);

    const [Info, setInfo] = useState({
        first_name: "",
        last_name: "",
        job: "",
        mobile: "",
        state_id: "",
        city_id: "",
        edit: false

    });


    const [load, setload] = useState(false);


    const sendProfileHandler = async () => {
        try {

            setload(true)
            const res = await dispatch(sendprofile(tokens,
                Info.first_name,
                Info.last_name,
                Info.job,
                Info.state_id,
                Info.city_id

            ))

            // console.log(res)

            if (res.status == "error") {
                setError(true)
                setMassage(res.message)


            }
            if (res.status == "success") {
                setError(true)
                setMassage("با موفقیت ثبت شد")
            }
            setload(false)


        } catch (err) {
            console.log(err);
        }
    };



    //پروفایل 
    const getprofileHandler = async () => {
        try {
            setloading(true)
            const res = await dispatch(getProfileinfo(tokens));
            //  console.log(res.data.data.user);
            setInfo(res.data.data.user)
            setnamecity(res.data.data.user.city)
            setLinks(res.data.data.links)
            if (res.data.data.user.city_id) {
                setCityhandler(res.data.data.user.state_id);
            }
            setloading(false)
        } catch (err) {
            console.log(err);
        }
    };

    const isfocuce = useIsFocused();
    useEffect(() => {
        getprofileHandler();
        setStatehandler();

        if (!tokens) {
            logOutHandler()
        }

    }, [isfocuce])














    // ست کردن استان
    const [Statetag, setStatetag] = useState("")
    const setStatehandler = async () => {
        try {
            const tok = await dispatch(getState(
                tokens
            ))

            //console.log(tok.data.data.states);

            if (tok.data.data.states.length > 0) {
                setStatetag(tok.data.data.states);

                if (Info.state_id) {
                    setCityhandler(Info.state_id);
                }
            }
        } catch (err) {

            console.log(err);
        }
    };


    let fresh = []
    for (let i = 0; i < Statetag.length; i++) {
        fresh.push(
            <Select.Item key={i} _text={{
                style: { fontFamily: "Montserrat" }
            }} label={Statetag[i].state} value={Statetag[i].id} />
        )
    }





    // ست کردن شهر ها
    const [Citytag, setCitytag] = useState("")
    const setCityhandler = async (id, edit = false) => {

        try {
            setOstan(id)
            if (edit == true) {
                setInfo({ ...Info, state_id: id });
            }
            const tok = await dispatch(getCity(
                tokens,
                id

            ))
            //console.log(tok.data.data.cities);
            setCitytag(tok.data.data.cities)
        } catch (err) {
            console.log(err);
        }

    };

    let Sectoring = []
    for (let i = 0; i < Citytag.length; i++) {
        Sectoring.push(
            <Select.Item key={i} _text={{
                style: { fontFamily: "Montserrat" }
            }} label={Citytag[i].city} value={Citytag[i].id} />
        )
    }


    const logOutHandler = async () => {
        try {
            //   console.log("logout");
            await dispatch(logOut());
            await AsyncStorage.removeItem("access_token");
            props.navigation.navigate("splash");
        } catch (err) {
            console.log(err);
        }
    };






    const handleOpenWithLinking = (url) => {
        Linking.openURL(url);
    };



    const onShare = async () => {

        try {
            const result = await Share.share({
                title: " پلنرس را دانلود کنید",
                message:
                    'https://npln.ir',
            });
            if (result.action === Share.sharedAction) {
                if (result.activityType) {
                    // shared with activity type of result.activityType
                } else {
                    // shared
                }
            } else if (result.action === Share.dismissedAction) {
                // dismissed
            }
        } catch (error) {
            Alert.alert(error.message);
        }
    };


   



    var pkg = require('../../package.json');


    const [isSmallScreen] = useMediaQuery({
        // minHeight: 280,
        // maxHeight: 480,
        maxWidth: 500
    });


    return !loading ? (
        <NativeBaseProvider>



            <View style={{
                width: isSmallScreen ? "100%" : 500,
                height: "100%",
                marginLeft: isSmallScreen ? 0 : "35%",
                backgroundColor: Colors.background,
                position: Platform.OS == "web" ? "fixed" : "relative"
            }}>







                <View style={{ flexDirection: "row", width: "100%", height: Platform.OS == "web" ? 60 : 80, alignItems: "center", justifyContent: "center", backgroundColor: Colors.primary }}>

                    <StatusBar backgroundColor={Colors.primary} />
                    <TouchableOpacity onPress={() => props.navigation.goBack()} style={styles.menu}   >
                        <Ionicons name="arrow-forward-outline" size={25} color={Colors.background} />
                    </TouchableOpacity>

                    <TouchableOpacity onPress={() => props.navigation.goBack()} style={styles.textheader}>
                        <Text style={{ fontFamily: "MontserratBold", fontSize: 15, color: Colors.background, padding: "5%" }}>
                            پروفایل
                        </Text>
                    </TouchableOpacity>

                    <TouchableOpacity style={styles.menu3} onPress={() => props.navigation.navigate("splash")}  >
                        <MaterialCommunityIcons name={"reload"} size={30} color={Colors.background} />
                        <Text style={{ fontFamily: "Montserrat", fontSize: 12, color: Colors.background }}>بارگزاری مجدد</Text>
                    </TouchableOpacity>

                    <TouchableOpacity onPress={() => setWallet(true)} style={styles.filter}>
                        <Text style={{ fontFamily: "MontserratBold", fontSize: 15, color: Colors.background, padding: "5%" }}>
                            خروج
                        </Text>
                        <Ionicons name="log-out-outline" size={30} color={Colors.background} />
                    </TouchableOpacity>

                </View>



                {/* {(loading ?
                        <View style={{ width: "100%", height: 50, alignItems: "center", justifyContent: "center", }} >
                            <ActivityIndicator
                                animating={loading} size={30} color={Colors.primary} />
                        </View>

: */}




                <ScrollView style={{ marginBottom: 10 }}>






                    {Info.edit !== true
                        ?

                        <TouchableOpacity onPress={() => { setInfo({ ...Info, edit: true }) }}
                            style={{ flexDirection: "row", width: "80%", height: 90, borderWidth: 3, borderStyle: 'dashed', marginBottom: "5%", borderColor: Colors.primary, marginTop: "10%", borderRadius: 10, marginLeft: "10%", }}>

                            <View style={{ width: "30%", height: "100%", flexDirection: "column", justifyContent: "center", alignItems: "center" }}>
                                <Ionicons name="create-outline" size={30} color={Colors.primary} />
                                <Text style={{ fontFamily: "MontserratBold", fontSize: 12, color: Colors.primary }}>ویرایش اطلاعات</Text>
                            </View>


                            <View style={{ width: "70%", height: "100%", flexDirection: "column", justifyContent: "center", alignItems: "flex-end", }}>
                                <Text style={{ fontFamily: "MontserratBold", fontSize: 19, color: Colors.primary, marginRight: 10 }}>{Info.first_name} {Info.last_name}</Text>
                                <Text style={{ fontFamily: "MontserratBold", fontSize: 16, color: Colors.primary, marginRight: 10 }}>{namecity.city}</Text>
                            </View>

                        </TouchableOpacity>
                        // <Btn
                        //     label="ویرایش اطلاعات"
                        //     style={{ marginLeft: "5%", marginTop: "10%", marginBottom: "5%", height: 55 }}
                        //     touchableStyle={{ backgroundColor: Colors.yellowlight, elevation: 0 }}
                        //     textStyle={{ bottom: 10 }}

                        //     onPress={() => {
                        //         setInfo({ ...Info, edit: true });

                        //     }} />
                        :

                        <SafeAreaView>



                            <INPU
                                label="نام "
                                styleview={{ marginTop: "13%", }}
                                stylelabel={{ width: "8%" }}
                                value={Info.first_name}
                                onChangeText={(text) => setInfo({ ...Info, first_name: text })}
                                styleinput={Platform.OS === "web" && { outlineColor: Colors.primary, outlineStyle: 'none' }}
                                keyboardType="default"

                            />

                            <INPU
                                label="نام خانوادگی"
                                styleview={{ marginTop: "9%", }}
                                stylelabel={{ width: "23%" }}
                                value={Info.last_name}
                                onChangeText={(text) => setInfo({ ...Info, last_name: text })}
                                styleinput={Platform.OS === "web" && { outlineColor: Colors.primary, outlineStyle: 'none' }}


                            />


                            <INPU
                                label="تخصص"
                                styleview={{ marginTop: "9%", }}
                                stylelabel={{ width: "15%" }}
                                value={Info.job}
                                onChangeText={(text) => setInfo({ ...Info, job: text })}
                                styleinput={Platform.OS === "web" && { outlineStyle: 'none', outlineColor: Colors.primary, }}


                            />
                            <INPU
                                label="شماره موبایل"
                                styleview={{ marginTop: "9%", }}
                                stylelabel={{ width: "23%" }}
                                editable={false}
                                value={Info.mobile}
                            // onChangeText={(text) => setSeller({ ...Seller, last_name: text })}



                            />





                            <View style={{
                                flexDirection: "column",
                                width: "100%",
                                alignItems: "center",
                                marginRight: "5%",
                                marginTop: 10
                            }}>

                                <View style={{
                                    width: "11%",
                                    height: 20,
                                    backgroundColor: Colors.background,
                                    alignItems: "center",
                                    zIndex: 2,
                                    left: Platform.OS === "web" ? "30%" : "36%",
                                    top: Platform.OS === "web" ? "7%" : "18%"

                                }}>
                                    <Text style={{ fontFamily: "Montserrat", fontSize: 12, color: Colors.secondText3 }}>
                                        استان
                                    </Text>
                                </View>

                                {Platform.OS === "web" ?
                                    "" :
                                    <Ionicons name="chevron-down-outline" size={18} color={Colors.secondText3} style={{ zIndex: 2, top: "34%", right: "40%" }} />
                                }



                                <Select
                                    // onOpen={() => setfocuse(true)}
                                    // onClose={() => setfocuse(false)}
                                    style={{ backgroundColor: Colors.background }}
                                    selectedValue={parseInt(Info.state_id)}
                                    w={Platform.OS === "web" ? 355 : "90%"}
                                    h={60}
                                    dropdownIcon={true}
                                    paddingRight={3}
                                    paddingLeft={Platform.OS === "web" ? "60%" : 0}
                                    borderColor={Colors.secondText3}
                                    borderWidth={1}
                                    bottom={1}

                                    fontFamily="Montserrat"
                                    fontSize={12}
                                    flexDirection="row-reverse"
                                    accessibilityLabel="استان خود را انتخاب کنید"
                                    placeholder="استان خود را انتخاب کنید"
                                    onValueChange={(i) => {
                                        setInfo({ ...Info, state_id: i })
                                        setCityhandler(i)
                                        //setCityhandler(i)
                                    }}
                                    _selectedItem={{
                                        bg: Colors.primary,
                                        startIcon: <CheckIcon size={5} color={Colors.black} />,

                                    }}
                                >

                                    {fresh}
                                </Select>

                            </View>







                            <View style={{
                                flexDirection: "column",
                                width: "100%",
                                alignItems: "center",
                                marginRight: "5%",

                            }}>

                                <View style={{
                                    width: "9%",
                                    height: 20,
                                    backgroundColor: Colors.background,
                                    alignItems: "center",
                                    zIndex: 2,
                                    left: Platform.OS === "web" ? "30%" : "36%",
                                    top: Platform.OS === "web" ? "7%" : "18%"

                                }}>
                                    <Text style={{ fontFamily: "Montserrat", fontSize: 12, color: Colors.secondText3 }}>
                                        شهر
                                    </Text>
                                </View>

                                {Platform.OS === "web" ?
                                    "" :
                                    <Ionicons name="chevron-down-outline" size={18} color={Colors.secondText3} style={{ zIndex: 2, top: "34%", right: "40%" }} />
                                }



                                <Select
                                    // onOpen={() => setfocuse1(true)}
                                    // onClose={() => setfocuse(false)}
                                    style={{ backgroundColor: Colors.background }}
                                    selectedValue={parseInt(Info.city_id)}
                                    w={Platform.OS === "web" ? 355 : "90%"}

                                    h={60}
                                    dropdownIcon={true}
                                    paddingRight={3}
                                    paddingLeft={Platform.OS === "web" ? "60%" : 0}
                                    borderColor={Colors.secondText3}
                                    borderWidth={1}
                                    bottom={1}

                                    fontFamily="Montserrat"
                                    fontSize={12}
                                    flexDirection="row-reverse"
                                    accessibilityLabel="شهر خود را انتخاب کنید"
                                    placeholder="شهر خود را انتخاب کنید"
                                    onValueChange={(t) => setInfo({ ...Info, city_id: t })}
                                    _selectedItem={{
                                        bg: Colors.primary,
                                        startIcon: <CheckIcon size={5} color={Colors.black} />,

                                    }}
                                >

                                    {Sectoring}
                                </Select>

                            </View>








                            <Btn
                                label="ثبت تغییرات "
                                style={{ marginLeft: "5%", marginTop: "10%", marginBottom: "5%", height: 55 }}

                                textStyle={{ bottom: 10 }}
                                loading={load}
                                colorspin={Colors.background}
                                sizespin={25}
                                onPress={() => {
                                    sendProfileHandler()
                                    //props.navigation.navigate("register1")
                                }} />

                        </SafeAreaView>

                    }



                    <TouchableOpacity
                        onPress={onShare}

                        style={{ flexDirection: "row", width: "80%", height: 30, alignItems: "center", justifyContent: "flex-end", marginBottom: "2%" }}>

                        <Text style={{ fontFamily: "MontserratBold", fontSize: 18, color: Colors.primary }}>اشتراک گذاری اپلیکیشن</Text>
                        <View style={{ marginLeft: 20, width: 30, height: 30, borderTopStartRadius: 5, borderBottomStartRadius: 5, backgroundColor: Colors.primary, justifyContent: "center", alignItems: "center" }}>
                            <Ionicons name="share-social" size={25} color={Colors.background} />
                        </View>

                    </TouchableOpacity>
                    <View style={{ width: "50%", height: 1, backgroundColor: Colors.primary, left: "20%" }}></View>




                    {Links.map((item, i) => {
                        return (
                            <SafeAreaView key={i}>
                                <TouchableOpacity
                                    onPress={() => {

                                        if (Platform.OS == "web") {
                                            handleOpenWithLinking(item.link)
                                        } else {
                                            props.navigation.navigate("web", {
                                                addressweb: item.link
                                            })
                                        }


                                    }}

                                    style={{ flexDirection: "row", width: "80%", height: 30, alignItems: "center", justifyContent: "flex-end", marginBottom: "2%" }}>

                                    <Text style={{ fontFamily: "MontserratBold", fontSize: 18, color: Colors.primary }}>{item.name}</Text>
                                    <View style={{ marginLeft: 20, width: 30, height: 30, borderTopStartRadius: 5, borderBottomStartRadius: 5, backgroundColor: Colors.primary, justifyContent: "center", alignItems: "center" }}>
                                        <Ionicons 
                                        name={item.name == "شرایط استفاده و قوانین" ? "newspaper"
                                            : item.name == "درباره پلنرس" ? "information"
                                                :item.name == "آموزش استفاده از اپلیکیشن" ? "book":
                                                item.name == "اشتراک گذاری اپ" ? "share-social"
                                                :item.name == "نسخه اپلیکیشن" ? "layers":
                                                "add"} size={25} color={Colors.background} />
                                    </View>
                                </TouchableOpacity>

                                <View style={{ width: "50%", height: 1, backgroundColor: Colors.primary, left: "20%" }}></View>

                            </SafeAreaView>

                        )
                    })}

                    {/* <View style={{ width: "80%", height: 30, alignItems: "center", justifyContent: "flex-end", marginBottom: "2%", flexDirection: "row" }}>

                        <Text style={{ fontFamily: "MontserratBold", fontSize: 18, color: Colors.primary }}>{Info.persian_expire_date}</Text>
                        <Text style={{ fontFamily: "MontserratBold", fontSize: 18, color: Colors.primary }}>انقضا عضویت : </Text>
                        <View style={{ marginLeft: 20, width: 30, height: 30, borderTopStartRadius: 5, borderBottomStartRadius: 5, backgroundColor: Colors.primary, justifyContent: "center", alignItems: "center" }}>
                            <MaterialCommunityIcons name="timer-sand" size={25} color={Colors.background} />
                        </View>
                    </View> */}
                  
                    <View style={{ width: "80%", height: 30, alignItems: "center", justifyContent: 'flex-end', marginBottom: "2%", flexDirection: "row" }}>

                        <Text style={{ fontFamily: "MontserratBold", fontSize: 18, color: Colors.primary }}>نسخه اپلیکیشن : {pkg.version}</Text>
                        <View style={{ marginLeft: 20, width: 30, height: 30, borderTopStartRadius: 5, borderBottomStartRadius: 5, backgroundColor: Colors.primary, justifyContent: "center", alignItems: "center" }}>
                            <Ionicons name="layers" size={25} color={Colors.background} />
                        </View>
                    </View>
                    <View style={{ width: "50%", height: 1, backgroundColor: Colors.primary, left: "20%" }}></View>



                    <AwesomeAlert
                        show={ERROR}
                        showProgress={false}
                        title={Massage == "با موفقیت ثبت شد" ? "" : "اخطار"}
                        message={Massage}
                        closeOnTouchOutside={false}
                        closeOnHardwareBackPress={false}
                        // showCancelButton={true}
                        showConfirmButton={true}
                        // cancelText="باشه"
                        confirmText="باشه"
                        confirmButtonColor={Colors.success}
                        // onCancelPressed={() => {
                        //   setShow(false);
                        // }}
                        onConfirmPressed={() => {
                            if (Massage == "با موفقیت ثبت شد") {
                                setError(false);
                                props.navigation.navigate("home")
                            } else {
                                setError(false)
                            }

                        }}
                        titleStyle={{ fontFamily: "MontserratBold", fontSize: 13, color: "red" }}
                        messageStyle={{ fontFamily: "Montserrat", fontSize: 13 }}
                        confirmButtonTextStyle={{ fontFamily: "Montserrat", fontSize: 13 }}
                    />








                    <AwesomeAlert
                        show={Wallet}
                        showProgress={false}
                        title="هشدار !"
                        message="از برنامه خارج می شوید؟"
                        closeOnTouchOutside={false}
                        closeOnHardwareBackPress={false}
                        showCancelButton={true}
                        showConfirmButton={true}
                        cancelText="انصراف"
                        confirmText="باشه"
                        confirmButtonColor={Colors.success}
                        cancelButtonColor={Colors.primary}
                        onCancelPressed={() => {
                            setWallet(false);
                        }}
                        onConfirmPressed={() => {
                            logOutHandler()
                            setWallet(false);

                        }}
                        titleStyle={{ fontFamily: "MontserratBold", fontSize: 13, color: Colors.primarydark }}
                        messageStyle={{ fontFamily: "Montserrat", fontSize: 13 }}
                        confirmButtonTextStyle={{ fontFamily: "Montserrat", fontSize: 13 }}
                        cancelButtonTextStyle={{ fontFamily: "Montserrat", fontSize: 13 }}

                    />






                </ScrollView>



                <View style={{
                    flexDirection: "row",
                    width: isSmallScreen ? "100%" : 500,
                    height: 60,
                    backgroundColor: Colors.primary,
                    position: Platform.OS === "web" ? "fixed" : "relative",
                    bottom: 0
                }}>
                    <TouchableOpacity onPress={() => props.navigation.navigate("orderlist", {
                        refresh: "true"
                    })} style={{ width: "15%", height: 60, position: "absolute", right: "5%", alignItems: "center", padding: 5 }}>
                        <Ionicons name="reader-outline" size={25} color={Colors.background} />
                        <Text style={{ fontFamily: "Montserrat", fontSize: 12, color: Colors.background }}>
                            سفارشات
                        </Text>
                    </TouchableOpacity>






                    <View style={{ width: "15%", height: 60, alignItems: "center", left: 15, top: 0 }}>
                        {/* <MaterialCommunityIcons name="badge-account-outline" size={25} color={Colors.background} />
                        <Text style={{ fontFamily: "Montserrat", fontSize: 12, color: Colors.background }}>
                            پروفایل
                        </Text> */}
                        <View style={{ width: 50, height: 50, borderRadius: 25, backgroundColor: Colors.yellowlight, borderWidth: 5, borderColor: Colors.background, bottom: 28, alignItems: "center", justifyContent: "center" }}>
                            <MaterialCommunityIcons name="badge-account-outline" size={25} color={Colors.background} />
                        </View>

                        <Text style={{ fontFamily: "Montserrat", fontSize: 12, color: Colors.yellow, position: 'absolute', bottom: 15 }}>
                            پروفایل
                        </Text>
                        <View style={{ width: 30, height: 5, borderRadius: 5, backgroundColor: Colors.yellowlight, position: 'absolute', bottom: 5 }}></View>
                    </View>









                    <TouchableOpacity onPress={() => props.navigation.navigate("home")} style={{ width: "30%", height: 60, left: "35%", alignItems: "center", flexDirection: "column", position: "absolute" }}>

                        {/* <View style={{ width: 50, height: 50, borderRadius: 25, backgroundColor: Colors.yellowlight, borderWidth: 5, borderColor: Colors.background, bottom: 28, alignItems: "center", justifyContent: "center" }}>
                            <Ionicons name="home-outline" size={20} color={Colors.background} />
                        </View>

                        <Text style={{ fontFamily: "Montserrat", fontSize: 12, color: Colors.yellow, position: 'absolute', bottom: 15 }}>
                            صفحه اصلی
                        </Text> */}
                        <Ionicons name="home-outline" size={25} color={Colors.background} />
                        <Text style={{ fontFamily: "Montserrat", fontSize: 12, color: Colors.background }}>
                            صفحه اصلی
                        </Text>

                    </TouchableOpacity>


                </View>

            </View>

        </NativeBaseProvider>
    ) : (
        <NativeBaseProvider>
            <View style={{ width: "100%", height: "100%", alignItems: "center", justifyContent: "center", backgroundColor: Colors.background }} >
                <ActivityIndicator
                    animating={loading} size={30} color={Colors.primary} />

                <Text style={{ fontFamily: "MontserratBold", fontSize: 25, color: Colors.primary, marginTop: 30 }}>لطفا شکیبا باشید...</Text>
            </View>
        </NativeBaseProvider>
    )
}

const styles = StyleSheet.create({

    viewContainer: {
        width: "100%",
        height: "100%",
        backgroundColor: Colors.background,
        position: Platform.OS == "web" ? "fixed" : "relative"
    },
    viewfooter: {
        flexDirection: "row",
        width: "100%",
        height: 60,
        backgroundColor: Colors.primary,
        position: Platform.OS === "web" ? "fixed" : "relative",
        bottom: 0
    },
    menu: {
        backgroundColor: Colors.primary,
        width: 40,
        height: 40,
        justifyContent: "center",
        alignItems: "center",
        position: "absolute",
        right: 15,
        top: Platform.OS == "web" ? "17%" : "35%",

    },
    menu3: {
        backgroundColor: Colors.primary,
        width: 80,
        height: 40,
        justifyContent: "center",
        alignItems: "center",
        position: "absolute",
        left: "40%",
        top: Platform.OS == "web" ? "15%" : "35%",
    },
    textheader: {
        backgroundColor: Colors.primary,
        width: 70,
        height: 50,
        alignItems: "center",
        justifyContent: "center",
        position: "absolute",
        right: "12%",
        top: Platform.OS == "web" ? "10%" : "22%"
    },
    filter: {
        backgroundColor: Colors.primary,
        width: 110,
        height: 50,
        alignItems: "center",
        justifyContent: "center",
        flexDirection: "row",
        position: "absolute",
        left: "0%",
        top: Platform.OS == "web" ? "12%" : "22%"
    },


})




export default Profile